import request from '../request'

export const getNoteByLcIdAndLevelIdAndGsId = (curriculumId, studentId, lcId, levelId, gsId, ulId, data) =>
  request
    .get(
      `/assessment/${curriculumId}/maestro/note/student/${studentId}/learning-continuum/${lcId}/levelId/${levelId}/granular-step/${gsId}/${ulId}`,
      data
    )
    .then((res) => res)

export const createNoteByLcIdAndLevelId = (curriculumId, studentId, lcId, levelId, gsId, data) =>
  request
    .post(
      `/assessment/${curriculumId}/maestro/note/student/${studentId}/learning-continuum/${lcId}/levelId/${levelId}/granular-step/${gsId}`,
      data
    )
    .then((res) => res)

export const deleteNote = (curriculumId, studentId, id) =>
  request.delete(`/assessment/${curriculumId}/maestro/note/student/${studentId}/${id}`).then((res) => res)
